import {
  inAppNotificationAction,
  pushViewAction,
} from '../../redux/actions/Actions';
import {appStore} from '../../redux/createStore';
import {getAPICall} from '../../services/apiCallsHandler';

import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';

import './NotificationIcon.css';

export const handleGetInNotification = () => {
  appStore.dispatch(
    inAppNotificationAction({
      notificationLoading: true,
      notifications: [],
      notificationCount: 0,
      defaultCriteriaToOpen: null,
      isNoNotifications: null,
    })
  );

  getAPICall(
    'notification',
    {
      isCallBack: true,
      errorTag: 'GET_IN_APP_NOTIFICATIONS',
      logInfoMsg: 'invoke in app notifications',
      redirectToOops: false,
    },
    {}
  ).then((res) => {
    const apiResponse = res;
    let notificationCount = 0;
    let defaultCriteriaToOpen = null;
    let isNoNotifications = true;

    if (apiResponse) {
      Object.keys(apiResponse).forEach((key, index) => {
        const notifications = Array.isArray(apiResponse[key])
          ? apiResponse[key]
          : [];

        if (defaultCriteriaToOpen == null && notifications.length > 0) {
          defaultCriteriaToOpen = index;
        }

        for (const notification of notifications) {
          if (isNoNotifications) isNoNotifications = false;
          if (notification.isRead !== true) {
            notificationCount++;
          }
        }
      });
    }

    appStore.dispatch(
      inAppNotificationAction({
        notificationLoading: false,
        notifications: apiResponse,
        notificationCount: notificationCount,
        defaultCriteriaToOpen: defaultCriteriaToOpen,
        isNoNotifications: isNoNotifications,
      })
    );
  });
};

const NotificationIcon = (props) => {
  const {t} = useTranslation();
  React.useEffect(() => {
    handleGetInNotification();
  }, []);
  return (
    <div
      className="notificationIconWrapper"
      onClick={() => appStore.dispatch(pushViewAction('notification'))}
      onKeyUp={() => {}}
    >
      <svg
        focusable="false"
        aria-hidden="true"
        fill="#666666"
        width="25"
        height="25"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <path d="M0 0h24v24H0z" fill="none"></path>
        <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z"></path>
      </svg>

      {props.inAppNotifications &&
      props.inAppNotifications.notificationCount > 0 ? (
        <div className="badge">
          {props.inAppNotifications.notificationCount}
        </div>
      ) : null}
      <p className="header-icon-title">{t('NOTIFICATION_ICON')}</p>
    </div>
  );
};

export const mapStateToProps = (state) => {
  return {
    inAppNotifications: state.appStates.inAppNotificationData,
  };
};

export default connect(mapStateToProps)(NotificationIcon);
